<template>
  <div>
    <div class="main" style="margin-top: 5px;">

      <div style="width: 90%;margin-left:2%;height:40px;line-height: 40px;">
        首页> <router-link :to="{name:'transferList'}" class="typeNav">
          农产品详情</router-link> > {{product.itemName}}
      </div>


      <div style="width: 100%; margin-top: 0px;height: auto;overflow: hidden;border：1px solid #ccc;">
        <div style="width: 45%;height:300px;margin-top:20px;float: left;">
          <div style="width: 90%;margin-left: 10%;border: 1px solid #ccc;height: 380px;">
            <el-carousel height="380px" width="100%">
              <el-carousel-item v-for="(item,index) in product.imgs.split(';')" :key="item">
                <img :src="item" style="height: 380px;width:100%">
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>

        <div style="width:35%;height: 380px;float: left;margin-top: 0px;margin-left: 1%;font-size: 14px;">
          <div style="width: 100%; font-size: 21px;min-height: 40px;line-height: 30px;margin-top: 30px;">
            <strong>{{product.prodName}}

            </strong>
          </div>
          <div style="width: 100%;height: 40px;line-height: 40px;">
            <div style="width:100%;height: 40px;line-height:40px;float: left;">
              价格：{{product.price}}
              {{getEnumByCode(product.priceUnit)}}
                </div>

          </div>
          <div style="width: 100%;height: 40px;line-height: 40px;">
            <div style="width:100%;height: 40px;line-height:40px;float: left;">
              发货地：{{product.unitName}}

            </div>
          </div>

         <div style="width: 100%;height: 40px;line-height: 40px;margin-top: 180px;">
           购买份数： <el-input-number v-model="order.buyVol"    size="medium" @change="handleChange" :min="1" :max="10" label="购买份数" style="margin-top: 2px;width:130px"></el-input-number>

           <el-button @click="showModalFunction()" type="primary" icon="el-icon-shopping-cart-1" style="background-color: #4cb050;width:150px;height:40px;font-size: 18px;margin-left: 10%;">
             立即下单</el-button>
         </div>

        </div>
      </div>



      <div style="width: 90%;height:40px;border-bottom:1px solid  #30c775dd;margin-left: 5%;margin-top: 10px;">

        <div class="perNav perNavActive"  style="border-right:none;">农产品详情</div>
      </div>




      <div style="width: 90%;margin-left: 5%;;height: auto;overflow: hidden;min-height: 100px;" v-html=product.content>

      </div>





    </div>

 <el-dialog title="填写收货基本信息" :visible.sync="showModal" width="80%" :before-close="handleClose" append-to-body>
      <div style="width: 100%;height: 500px;">
        <el-form ref="signUp" :model="signUp" :inline="true" label-width="100px" style="margin-top: 10px;">
          <el-col :span="24">
            <el-form-item label="收货人" label-width="150px">
              <el-input v-model="order.name" placeholder="请输入收货人"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="手机号" label-width="150px">
              <el-input v-model="order.phone" placeholder="请输入手机号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item label="收货地址" label-width="150px">
              <el-input v-model="order.address" placeholder="请输入收货地址" style="width: 300px;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item label="备注" label-width="150px">
              <el-input v-model="order.remark" placeholder="请输入收货把备注" style="width: 300px;"></el-input>
            </el-form-item>
          </el-col>
          <el-button type="primary" @click="buy()" icon="el-icon-check" style="margin-left: 31%;width:300px">提交
            </el-button>

          </el-form>

  </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        product: {},
        id: "",
        order:{
            prodId:"",
            buyVol:1,
            address:"",
            priceUnit:"",
            reamrk:"",
            amount:"",
            price:"",
          },
          emnus:[],

        showModal: false,



      }
    },
    created() {
      this.getDetails();
      this.id = this.$route.query.id;
     // this.signUp.transferId = this.$route.query.id;

      this.getEmnusByType(1);
      },
      methods: {
        async getEmnusByType(type){
          const action = "/web/queryEnumsByType/"+type;
          const {
            data: res
          } = await this.$http.get(action);
          this.emnus=res.data;
        },
         getEnumByCode(code){
          return this.emnus.find(d => d.code === code).desc;
        },
      chnageCurrentNav(nav) {
        this.currentNav = nav;
      },
      getUserType() {
        this.userType = this.signUp.type;
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
      showModalFunction(){
        this.judgeLogin();
        this.showModal=true;
      },

      async judgeLogin() {

        if (localStorage.getItem("token") == "" || localStorage.getItem("token") == null || localStorage.getItem(
            "token") == undefined) {
          this.$message.error("请登录");
          this.$router.push("/");
          const {
            href
          } = this.$router.resolve({
            path: "/login",
            query: {},
          });
          window.open(href, '_blank');

          return;
        } else {
          const action = "/web/verifyToken";
          const {
            data: res
          } = await this.$http.get(action);
          if (res.code == 108) {
            this.$message.error("请登录");
            this.$router.push("/");
            const {
              href
            } = this.$router.resolve({
              path: "/login",
              query: {},
            });
            window.open(href, '_blank');
            return;
          }

          this.signModalFlag = true;
        }
      },
      async getDetails() {
        const action = "/web/queryProductById/" + this.$route.query.id;
        const {
          data: res
        } = await this.$http.get(action);
        this.product = res.data;
        this.order.price=this.product.price;
        this.order.prodId=this.product.id;
        this.order.priceUnit=this.product.priceUnit;
      },
      buy(){
        this.judgeLogin();
        if(this.order.buyVol==0){
          this.$message.error("请选择要购买的数量");
          return;
        }
        if(this.order.address==""){
          this.$message.error("请输入购买地址");
          return;
        }
        this.order.amount=this.order.buyVol*this.product.price;
        this.$http.post("/web/order/buy", this.order).then((res) => {
          if(res.data.msg == "success") {
            this.showModal=false;

            this.$message.success("下单成功，即将跳转到上传转账记录界面");
            this.$router.push("/order-search");

            this.signModalFlag = false;
          } else {
            this.$message.success(res.data.msg)
          }

        });
      },


      handleClose(done) {
        done();
      },


    }



  };
</script>

<style scoped="">
  @import url("../../../assets/css/index.css");
  @import url("../../../assets/css/base.css");
  @import url("../../../assets/css/main.css");
  @import url("../../../assets/css/news.css");


  .perNav {
    width: 100px;
    height: 39px;
    line-height: 39px;
    text-align: center;
    float: left;
    margin-bottom: 10px;
    font-weight: 500;
    font-size: 16px;
    border: 1px solid #d1d1d1;
    border-bottom: none;
    cursor: pointer;
  }

  .perNavActive {
    background-color: #30c775dd;
    border: 1px solid #30c775dd !important;
    color: white;
  }


  .table_lb {
    background: #f6f6f6;
    height: 40px;
    font-size: 20px;
    border-bottom: 2px solid #4cb050;
    width: 100%;

  }

  .el-descriptions__title {
    font-size: 18px !important;
  }

  .per_title {
    width: 99%;
    margin-left: 1%;
    height: 40px;
    line-height: 2.5rem;
    font-size: 20px;
  }

  .per_content {
    width: 100%;
    margin-left: 0%;
    height: 285px;
    border: 1px solid black;
  }

  .per_per {
    width: 100%;
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid black;
  }

  .per_per_name {
    width: 49%;
    height: 40px;
    float: left;
    padding-left: 10px;
    border-right: 1px solid #ccc;
  }



  .hone-container {
    height: 100%;
  }

  a-layout-content {
    height: 100%;
  }

  .ant-layout-header {
    /* 2850A0 */
    padding: 0px;
    background-color: #3c8dbc !important;
  }

  .main {
    width: 1220px;
    margin: 0 auto;
    height: auto;
    overflow: hidden;
    background-color: white;
    margin-top: 5px;
  }
</style>
